import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import JisrLoader from 'components/global/JisrLoader'

const Container = ({ children, fetching, widgetStyle, ...rest }) => (
  <div
    className={classNames(
      'jisr-widget__container',
      widgetStyle && `jisr-widget__container--${widgetStyle}`,
    )}
    {...rest}
  >
    {fetching && <JisrLoader absolute />}
    {children}
  </div>
)

Container.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  widgetStyle: PropTypes.string,
  fetching: PropTypes.bool,
}

export default Container
